import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CSpinner,
  CLabel,
  CTextarea
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  FormGroup
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import DragAndDropActivity from "../../../../components/DragAndDrop/DragAndDropActivity";
import Loading from "../../../../components/Loading";
import ModalActivity from "../../../../components/Modal/ModalActivity";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import QuestionListCreate from "../../../../components/QuestionListCreate";
import QuestionListImportModal from "../../../../components/QuestionListImportModal/QuestionListImportModal";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class EvaluationADRCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      edit: false,
      // listName: "",
      fase: 1,
      fases: 1,
      name: "",
      private: false,
      description: "",
      disciplineId: "",
      disciplinesList: [],
      origins: [],
      originId: null,
      serieId: null,
      serieList: [],
      type: 6,
      types: [],
      // types_aux: [],
      // difficulty_levels: [],
      modal: false,
      modalProps: {
        modalCompoent: 1, // 1- content , 2-question
        title: "",
        type: 0,
        typeName: ""
      },
      contentList: [],
      // bewList: false,
      editListId: null,
      cloneListId: null,
      creating: true,
      editing: false,
      result_type: "SEMPRE",
      uploadPDFModal: false,
      selectedActivityPDF: null,
      file: null
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    const { id } = this.props.match.params;
    let { contentType } = this.props.match.params;
    if (contentType) {
      this.setState({
        // contentType
      });
    }

    let objDisciplinesList = {
      user_id: this.props.user.user.id
    };

    axios
      .all([
        axios.get(`${URL.api}content/type/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}community/room_user/list`, objDisciplinesList, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}classification/discipline/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}classification/serie/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}adr/origins/selectorList`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (respType, respRoomUser, respDiscipline, respSeries, respOrigins) => {
            if (respType.data.success) {
              let types = [];
              respType.data.data.forEach(type => {
                if (type.activity === true) {
                  if (type.id === 12) {
                    types.push(type);
                  }
                }
              });

              let origins = [];
              respOrigins.data.data.forEach(origin => {
                origins.push(origin);
              });

              let disciplinesList = [];

              if (
                ["G", "U", "R", "E"].includes(
                  this.props.general.active_roles.type
                )
              ) {
                disciplinesList = respDiscipline.data.data.map(discipline => ({
                  id: discipline.id,
                  name: discipline.name
                }));
              } else {
                let check;
                for (let i = 0; i < respRoomUser.data.data.length; i++) {
                  for (
                    let j = 0;
                    j < respRoomUser.data.data[i].disciplines?.length;
                    j++
                  ) {
                    check = true;

                    if (
                      respRoomUser.data.data[i].id ===
                      respRoomUser.data.data[i].disciplines[j].room_user_id
                    ) {
                      for (let k = 0; k < disciplinesList.length; k++) {
                        if (
                          disciplinesList[k].id ===
                          respRoomUser.data.data[i].disciplines[j].discipline_id
                        ) {
                          check = false;
                          break;
                        }
                      }
                      if (check) {
                        disciplinesList.push({
                          id: respRoomUser.data.data[i].disciplines[j]
                            .discipline_id,
                          name: respRoomUser.data.data[i].disciplines[j]
                            .discipline_name
                        });
                      }
                    }
                  }
                }

                if (disciplinesList.length === 0) {
                  disciplinesList = respDiscipline.data.data.map(
                    discipline => ({
                      id: discipline.id,
                      name: discipline.name
                    })
                  );
                }
              }

              this.setState({
                types,
                disciplinesList,
                serieList: respSeries.data.data,
                creating: false,
                origins
              });
            }
          },
          error => {
            this.error(error.response.statusText);
          }
        )
      );

    if (id) {
      this.setState(
        () => ({
          edit: true
        }),
        () => {
          axios
            .get(`${URL.api}activity/activity/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(respActivity => {
              const isFinished = respActivity.data.data.status_id !== 1;
              if (isFinished) this.props.history.push("/evaluation/adr/list");

              let contentList = [];
              for (let i = 0; i < respActivity.data.data.items.length; i++) {
                let obj = {
                  type: respActivity.data.data.items[i].type_id,
                  list: {
                    id: respActivity.data.data.items[i].obj_id,
                    name: respActivity.data.data.items[i].name
                  },
                  link: respActivity.data.data.items[i].link
                };
                contentList.push(obj);
              }

              let types = [];
              if (respActivity.data.data.type_id === 3) {
                this.state.types.forEach(type => {
                  if (type.id === 12) {
                    types.push(type);
                  }
                });
              } else {
                this.state.types.forEach(type => {
                  types.push(type);
                });
              }

              this.setState(() => ({
                loading: false,
                name: respActivity.data.data.name,
                description: respActivity.data.data.description,
                private: respActivity.data.data.private,
                disciplineId: respActivity.data.data.discipline_id,
                serieId: respActivity.data.data.serie_id,
                file: respActivity.data.data?.file,
                types,
                contentList,
                result_type: respActivity.data.data.result_type,
                creating: false,
                originId: respActivity.data.data.adr_origin
              }));
            });
        }
      );
    } else {
      this.setState({
        loading: false
      });
    }
  }

  previous() {
    this.setState(state => ({
      fase: Math.max(1, state.fase - 1)
    }));
  }

  next() {
    this.setState(state => ({
      fase: Math.min(state.fases, state.fase + 1)
    }));
  }

  getAtualFase = fase => {
    this.setState({
      fase
    });
  };

  changeName = e => {
    let { value } = e.target;
    this.setState({
      name: value
    });
  };

  changeType = e => {
    let { value } = e.target;
    this.setState({
      type: Number.parseInt(value)
    });
  };

  changeOrigin = e => {
    let { value } = e.target;
    this.setState({
      originId: Number.parseInt(value)
    });
  };

  changeDescription = e => {
    let { value } = e.target;
    this.setState({
      description: value
    });
  };

  changePrivate = e => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      private: !this.state.private
    });
  };

  changeResultType = e => {
    let { value } = e.target;
    this.setState({
      result_type: value
    });
  };

  changeDiscipline = e => {
    let { value } = e.target;
    this.setState({
      disciplineId: value
    });
  };

  changeSerie = e => {
    let { value } = e.target;
    this.setState({
      serieId: value
    });
  };

  getOrder = order => {
    this.setState({
      contentList: order
    });
  };

  getSelected = selected => {
    this.setState({
      // selected
    });
  };

  editItem = (type, id, item) => {
    const editIndex = this.state.contentList.findIndex(
      item => item.type === type && item.list.id === id
    );

    if (type === 12) {
      this.setState({
        editListId: id,
        // cloneList: null,
        newList: true
      });
    }

    this.setState(
      {
        editing: true
        // editIndex
      },
      () => this.selectedItem(item)
    );
  };

  selectedItem = item => {
    if (item.id <= 12) {
      this.setState(
        {
          modalProps: {
            // eslint-disable-next-line react/no-access-state-in-setstate
            ...this.state.modalProps,
            modalCompoent: 1,
            type: item.id,
            typeName: item.name,
            title: `Selecione - ${item.name}`
          }
        },
        () => {
          this.toggleModal();
        }
      );
    } else if (item.id === 17) {
      this.setState(
        {
          modalProps: {
            // eslint-disable-next-line react/no-access-state-in-setstate
            ...this.state.modalProps,
            modalCompoent: 1,
            type: item.id,
            typeName: item.name,
            title: `Selecione - ${item.name}`
          }
        },
        () => {
          this.toggleModal();
        }
      );
    }
  };

  selectedListItem = list => {
    let { id, name } = list;
    let contentList = [];

    if (this.state.editing) {
      let checkEdit = false;
      this.state.contentList.forEach(content => {
        if (content.type === 12) {
          checkEdit = true;
          content.list.id = id;
          content.list.name = name;
        }
        contentList.push(content);
      });

      if (!checkEdit) {
        let obj = {
          type: 12,
          list: {
            id,
            name
          }
        };

        contentList.push(obj);
      }
    } else {
      this.state.contentList.forEach(list => {
        contentList.push(list);
      });

      let check = true;
      if (contentList.length > 0) {
        check = false;
        toastr.error(
          "Erro",
          "Você só pode adicionar uma lista. Caso deseje trocar, exclua a lista já adicionada."
        );
      }

      let obj = {
        type: 12,
        list: {
          id,
          name
        }
      };

      if (check) {
        contentList.push(obj);
      }
    }

    this.setState(
      {
        contentList,
        editListId: null
      },
      () => {
        this.toggleModal();
      }
    );
  };

  removeItem = (type, id) => {
    let contentList = [];
    this.state.contentList.forEach(item => {
      if (item.type !== type || item.list.id !== id) {
        contentList.push(item);
      }
    });

    this.setState({
      contentList
    });
  };

  toggleModal = () => {
    this.setState(state => ({
      modal: !state.modal,
      newList: state.modal ? false : state.newList,
      editing: state.modal ? false : state.editing
    }));
  };

  getContent = content => {
    let contentList = [];
    this.state.contentList.forEach(list => {
      contentList.push(list);
    });

    for (let i = 0; i < content.list.length; i++) {
      let check = true;
      let obj = {
        type: content.type,
        list: content.list[i]
      };

      for (let j = 0; j < contentList.length; j++) {
        if (
          content.type === contentList[j].type &&
          content.list[i].id === contentList[j].list.id
        ) {
          check = false;
          toastr.error(
            "Erro",
            `O conteúdo "${content.list[i].name}" já tinha sido adicionado antes.`
          );
          break;
        }
      }

      if (check) {
        contentList.push(obj);
      }
    }

    this.setState(
      {
        contentList
      },
      () => {
        this.toggleModal();
      }
    );
  };

  saveActivity = () => {
    let emptyField = true;
    let obj = {
      name: this.state.name,
      description: this.state.description,
      user_id: this.props.user.user.id,
      private: this.state.private,
      discipline_id: this.state.disciplineId.toString(),
      serie_id: this.state.serieId,
      disciplines: [this.state.disciplineId],
      items: this.state.contentList,
      type_id: this.state.type,
      evaluation: true,
      result_type: this.state.result_type,
      sequential_execution: false,
      adr_origin: this.state.originId
    };

    if (obj.name === "") {
      toastr.error("Erro", "Campo nome vazio");
      emptyField = false;
    }

    if (!obj.adr_origin) {
      toastr.error("Erro", "Campo de origem vazio");
      emptyField = false;
    }

    if (obj.discipline_id === "") {
      toastr.error("Erro", "Campo componente curricular vazio");
      emptyField = false;
    }

    if (obj.type_id === 6 && !obj.serie_id) {
      toastr.error("Erro", "Campo série vazio");
      emptyField = false;
    }

    if (obj.private === "") {
      toastr.error("Erro", "Campo liberar atividade vazio");
      emptyField = false;
    }

    if (obj.description === "") {
      toastr.error("Erro", "Campo descrição vazio");
      emptyField = false;
    }

    if (emptyField) {
      this.setState({ creating: true });

      if (this.state.edit) {
        this.editActivity(obj);
      } else {
        this.createActivity(obj);
      }
    }
  };

  createActivity = obj => {
    axios
      .post(`${URL.api}activity/activity/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push(`/evaluation/adr/list`);
          } else {
            this.setState({ creating: false });
          }
        },
        () => {
          this.setState({ creating: false });
        }
      );
  };

  editActivity = obj => {
    obj.id = this.props.match.params.id;
    axios
      .post(`${URL.api}activity/activity/update`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push(`/evaluation/adr/list`);
          } else {
            this.setState({ creating: false });
          }
        },
        () => {
          this.setState({ creating: false });
        }
      );
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  uploadPDF = async () => {
    const { id } = this.props.match.params;
    const formData = new FormData();
    formData.append("file0", this.state.selectedActivityPDF);

    try {
      const uploadResponse = await axios.post(
        `${URL.api}file/evaluation/${this.props.user.user.id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      );

      const { name, url } = uploadResponse.data.files[0];

      const obj = {
        activity_id: id,
        name,
        link: URL.public + url
      };

      const pdfUpdateResponse = await axios.post(
        `${URL.api}activity/activity/insertFile`,
        obj,
        {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      );

      this.setState({
        file: pdfUpdateResponse.data.data
      });

      toastr.success("Sucesso", "Prova enviada com sucesso.");
    } catch (error) {
      toastr.error("Erro", "Erro ao enviar a prova.");
    }
  };

  deleteUploadedPDF = async () => {
    const { id } = this.props.match.params;

    try {
      await axios.post(
        `${URL.api}removeFile/evaluation/${this.props.user.user.id}`,
        { name: this.state.file.name },
        {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      );

      await axios.post(
        `${URL.api}activity/activity/deleteFile`,
        { activity_id: id },
        {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      );

      this.setState({ file: null });

      toastr.success("Sucesso", "PDF removido com sucesso.");
    } catch (error) {
      toastr.error("Erro", "Erro ao remover a prova.");
    }
  };

  render() {
    return (
      <>
        <Prompt
          when={!this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/evaluation/adr/list", to: "/evaluation/adr/list" }]}
        />

        <Modal isOpen={this.state.uploadPDFModal} size="md">
          <form
            onSubmit={e => {
              e.preventDefault();
              this.uploadPDF();
            }}
          >
            <ModalHeader
              toggle={() => this.setState({ uploadPDFModal: false })}
            >
              Upload de Prova
            </ModalHeader>
            <ModalBody>
              {this.state.file ? (
                <button
                  className="d-flex border rounded p-0 w-100"
                  type="button"
                  onClick={() => window.open(this.state.file.link, "_blank")}
                >
                  <div className="bg-warning p-3 h-100 rounded-left">
                    <i className="fa fa-file"></i>
                  </div>
                  <div className="d-flex align-items-center justify-content-start my-3 mx-2">
                    {this.state.file.name}
                  </div>
                </button>
              ) : (
                <div className="form-group">
                  <label>Selecione o arquivo PDF</label>
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={e =>
                      this.setState({ selectedActivityPDF: e.target.files[0] })
                    }
                  />
                </div>
              )}
            </ModalBody>
            {this.state.file ? (
              <ModalFooter>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => this.deleteUploadedPDF()}
                >
                  <i className="fa fa-trash mr-1"></i>
                  Remover PDF
                </button>
              </ModalFooter>
            ) : (
              <ModalFooter>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => this.setState({ uploadPDFModal: false })}
                >
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  Enviar
                </button>
              </ModalFooter>
            )}
          </form>
        </Modal>
        {!this.state.loading ? (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Avaliação" : "Criar Avaliação"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite a avaliação"
                    : "Crie uma nova avaliação"}
                </div>
              </div>
              {this.props.match.params.id && (
                <CButton
                  color="secondary"
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => this.setState({ uploadPDFModal: true })}
                >
                  {this.state.file ? (
                    <>
                      <i className="fa fa-eye mr-2"></i>
                      <p className="m-0">Visualizar PDF da prova</p>
                    </>
                  ) : (
                    <>
                      <i className="fa fa-cloud-upload mr-2"></i>
                      <p className="m-0">Fazer upload da prova</p>
                    </>
                  )}
                </CButton>
              )}
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center ml-2"
                onClick={() => this.saveActivity()}
                disabled={this.state.creating}
              >
                <span style={this.state.creating ? { opacity: 0 } : null}>
                  Salvar
                </span>
                {this.state.creating && (
                  <CSpinner
                    size="sm"
                    color="white"
                    style={{ position: "absolute" }}
                  />
                )}
              </CButton>
            </CCardHeader>
            <CCardBody>
              <div className="myRow">
                <FormGroup className="mb3">
                  <CLabel>Nome da Avaliação</CLabel>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="text"
                      value={this.state.name}
                      onChange={this.changeName}
                      placeholder="Nome da Avaliação"
                    />
                  </InputGroup>
                </FormGroup>
                {this.props.general.active_roles.role_id <= 2 && (
                  <>
                    <FormGroup className="mb3" hidden>
                      <CLabel>Tipo de avaliação</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="select"
                          value={this.state.type}
                          // onChange={this.changeType}
                          disabled
                        >
                          <option value="4">Padrão</option>
                          <option value="6">ADR</option>
                        </Input>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb3">
                      <CLabel>Origem</CLabel>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-text-width" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="select"
                          value={this.state.originId}
                          onChange={this.changeOrigin}
                        >
                          <option value={null}>Selecione uma origem</option>
                          {this.state.origins.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Input>
                      </InputGroup>
                    </FormGroup>
                  </>
                )}

                <FormGroup className="mb3">
                  <CLabel>Componente curricular</CLabel>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      defaultValue={this.state.disciplineId}
                      onChange={this.changeDiscipline}
                    >
                      <option value="">Escolha o componente curricular</option>
                      {this.state.disciplinesList.map(discipline => (
                        <option key={discipline.id} value={discipline.id}>
                          {discipline.name}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                </FormGroup>

                <FormGroup className="mb3">
                  <CLabel>Série</CLabel>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      defaultValue={this.state.serieId}
                      onChange={this.changeSerie}
                    >
                      <option value={null}>Escolha uma série</option>
                      {this.state.serieList.map(serie => (
                        <option key={serie.id} value={serie.id}>
                          {serie.name}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                </FormGroup>

                {/* <FormGroup className="mb3">
                  <CLabel>Tornar Pública (Opcional)</CLabel>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      defaultValue={this.state.private}
                      onChange={this.changePrivate}
                    >
                      <option value={false}>Não</option>
                      <option value>Sim</option>
                    </Input>
                  </InputGroup>
                </FormGroup> */}

                <FormGroup className="mb3">
                  <CLabel>Tipo de resultado</CLabel>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      value={this.state.result_type}
                      onChange={this.changeResultType}
                    >
                      <option value="SEMPRE">
                        Sempre mostrar nota e gabarito
                      </option>
                      <option value="TERMINO">
                        Mostrar nota e gabarito somente ao término
                      </option>
                      <option value="NOTA">
                        Mostrar nota, mas gabarito somente ao término
                      </option>
                      <option value="NUNCA">
                        Nunca mostrar nota e gabarito
                      </option>
                    </Input>
                  </InputGroup>
                </FormGroup>

                <FormGroup className="mb3">
                  <CLabel>Descrição</CLabel>
                  <InputGroup>
                    <CTextarea
                      value={this.state.description}
                      onChange={this.changeDescription}
                      placeholder="Descrição"
                    />
                  </InputGroup>
                </FormGroup>

                {this.state.types.length > 0 ? (
                  <>
                    <DragAndDropActivity
                      list={this.state.types}
                      list2={this.state.contentList}
                      dropArea
                      dropName="Lista selecionada"
                      getOrder={this.getOrder}
                      getSelected={this.getSelected}
                      editItem={this.editItem}
                      selectedItem={this.selectedItem}
                      removeItem={this.removeItem}
                      direction="horizontal"
                      dontChangeListOnSelect
                    />
                  </>
                ) : (
                  <Loading top="45" left="50" />
                )}
              </div>

              {this.state.modal && (
                <ModalActivity
                  toggleModal={this.toggleModal}
                  modalState={this.state.modal}
                  title={this.state.modalProps.title}
                  className=" educandus modalActivity"
                  backdrop="static"
                  size="xl"
                  noFooter
                  disableCloseButton
                  onClose={() =>
                    this.setState({ editing: false, newList: false })
                  }
                >
                  {this.state.modalProps.type === 12 ? (
                    this.state.newList ? (
                      <QuestionListCreate
                        newList={this.selectedListItem}
                        history={this.props.history}
                        editListId={this.state.editListId}
                        cloneListId={this.state.cloneListId}
                        name={this.state.name}
                        closeModal={this.closeModal}
                        afterClone={id =>
                          this.setState({
                            editListId: id,
                            cloneListId: undefined
                          })
                        }
                      />
                    ) : (
                      <QuestionListImportModal
                        selectedListChanger={this.selectedListItem}
                        newList={() =>
                          this.setState({
                            // eslint-disable-next-line react/no-access-state-in-setstate
                            newList: !this.state.newList,
                            cloneListId: null,
                            editListId: null
                          })
                        }
                        history={this.props.history}
                        editList={id =>
                          this.setState({
                            editListId: id,
                            cloneListId: null,
                            newList: true
                          })
                        }
                        cloneList={id =>
                          this.setState({
                            cloneListId: id,
                            editListId: null,
                            newList: true
                          })
                        }
                      />
                    )
                  ) : (
                    ""
                  )}
                </ModalActivity>
              )}
            </CCardBody>
          </CCard>
        ) : (
          <Loading top="45" left="50" />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationADRCreate);
